<template>
  <div
    class="two-drawer-layout__screen-height--after-secondary-subheader tw-p-6"
  >
    <div
      class="
        tw-rounded-lg
        tw-h-full
        tw-max-w-condensed-content
        tw-mx-auto
        tw-flex
        tw-flex-row
        tw-w-full
      "
      :class="borderClasses"
    >
      <SfAssistantChecksEmpty v-if="!hasChecks && !loading" />
      <template v-else>
        <div
          class="
            tw-h-full
            tw-shrink-0
            tw-grow
            tw-rounded-l-lg
            tw-p-4
            tw-w-condensed-sidepane
            tw-max-w-condensed-sidepane
            tw-overflow-y-auto
            tw-bg-sf-neutral-subtle-1
          "
        >
          <div v-if="loading">
            <SfSkeletonLoader
              v-for="i in 15"
              :key="i"
              height="2rem"
              :width="['10rem', '15rem', '20rem'][i % 3]"
              class="tw-px-2"
            />
          </div>
          <SfAssistantChecksLeftSidepane
            v-else
            :selected-category="selectedCategory"
            :selected-item="selectedItem"
            @select="setSelected"
          >
          </SfAssistantChecksLeftSidepane>
        </div>
        <div
          data-testid="assistant-checks-container"
          class="
            tw-h-full
            tw-shrink
            tw-grow
            tw-overflow-y-auto
            tw-rounded-r-lg
            tw-bg-sf-snow-lighter
          "
        >
          <div v-if="loading">
            <RemarkV2Skeleton v-for="i in 4" :key="i" class="tw-mx-2 tw-my-1" />
          </div>
          <SfAssistantChecksContainer
            v-else
            :selected-category="selectedCategory"
            :selected-item="selectedItem"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import RemarkV2Skeleton from '@app/shared/vue/components/molecules/remark-v2/remark-v2-skeleton.vue'
import SfAssistantChecksContainer from '@app/application/sf-assistant-checks/components/sf-assistant-checks-container.vue'
import SfAssistantChecksEmpty from '@app/application/sf-assistant-checks/components/sf-assistant-checks-empty.vue'
import SfAssistantChecksLeftSidepane from '@app/application/sf-assistant-checks/components/sf-assistant-checks-left-sidepane.vue'
import SfSkeletonLoader from '@app/shared/vue/components/sf-skeleton-loader.vue'
import { UNREAD_CHECKS } from '@app/application/sf-assistant-checks/utils'
import { useSfAssistantChecksPage } from '../stores/page'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfAssistantChecksPage',
})

interface Props {
  contextId?: string
}
const props = defineProps<Props>()

const sfAssistantChecksPageStore = useSfAssistantChecksPage()
const { loading, hasChecks } = storeToRefs(sfAssistantChecksPageStore)

if (props.contextId) {
  sfAssistantChecksPageStore.setWorkflowId(parseInt(props.contextId, 10))
}
sfAssistantChecksPageStore.fetchAll()

const selectedCategory = ref(UNREAD_CHECKS)
const selectedItem = ref('')

const borderClasses = computed(() => {
  return !hasChecks.value && !loading.value
    ? []
    : ['tw-border', 'tw-border-solid', 'tw-border-sf-neutral-lighter-2']
})

const setSelected = (category: string, item: string): void => {
  selectedCategory.value = category
  selectedItem.value = item
}
</script>
